/**
 * Normalise post date string (YYYY-MM-DD) to ISO 8601 for <time> and JSON-LD.
 */
export function toPublishedDateTime(dateStr, time = '08:00:00', tz = '+05:30') {
  if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
  return `${dateStr}T${time}${tz}`;
}

/** Human-readable date for India locale */
export function formatPublishedDate(dateStr) {
  if (!dateStr) return '';
  try {
    const d = new Date(`${dateStr}T12:00:00`);
    return new Intl.DateTimeFormat('en-IN', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(d);
  } catch {
    return dateStr;
  }
}
